import React from 'react';
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import { sharedStyles } from './SharedPDFStyles';

const EgitimReportPDF = ({ data, logos }) => {
  return (
    <Document>
      <Page size="A4" style={sharedStyles.page}>
        <View style={sharedStyles.header}>
          <View style={sharedStyles.businessInfo}>
            {logos.length > 0 && (
              <View style={sharedStyles.logoContainer}>
                {logos.slice(0, 3).map((logo, index) => (
                  <Image key={index} src={logo.data} style={sharedStyles.logo} />
                ))}
              </View>
            )}
            <Text style={sharedStyles.businessName}>{data.centerName || 'Education Center'}</Text>
          </View>
          <View style={sharedStyles.documentTitle}>
            <Text style={sharedStyles.title}>Student Fee Report</Text>
            <Text style={sharedStyles.documentInfo}>Date: {data.date}</Text>
            <Text style={sharedStyles.documentInfo}>Student: {data.studentName}</Text>
            <Text style={sharedStyles.documentInfo}>Student ID: {data.studentId}</Text>
            <Text style={sharedStyles.documentInfo}>Period: {data.reportPeriod}</Text>
          </View>
        </View>

        <View style={sharedStyles.section}>
          <Text style={sharedStyles.sectionTitle}>Course Fees</Text>
          <View style={sharedStyles.table}>
            <View style={sharedStyles.tableHeader}>
              <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>Course Name</Text>
              <Text style={sharedStyles.tableCell}>Duration</Text>
              <Text style={sharedStyles.tableCellRight}>Fee</Text>
              <Text style={sharedStyles.tableCellRight}>Paid</Text>
              <Text style={sharedStyles.tableCellRight}>Remaining</Text>
            </View>
            {data.fees && data.fees.map((fee, index) => (
              <View key={index} style={sharedStyles.tableRow}>
                <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>{fee.courseName}</Text>
                <Text style={sharedStyles.tableCell}>{fee.duration}</Text>
                <Text style={sharedStyles.tableCellRight}>${fee.fee.toFixed(2)}</Text>
                <Text style={sharedStyles.tableCellRight}>${fee.paid.toFixed(2)}</Text>
                <Text style={sharedStyles.tableCellRight}>${fee.remaining.toFixed(2)}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={sharedStyles.summary}>
          <View style={sharedStyles.summaryBox}>
            <View style={sharedStyles.summaryRow}>
              <Text style={sharedStyles.summaryLabel}>Total Fee:</Text>
              <Text style={sharedStyles.summaryValue}>${data.totalFee?.toFixed(2) || '0.00'}</Text>
            </View>
            <View style={sharedStyles.summaryRow}>
              <Text style={{ ...sharedStyles.summaryLabel, color: '#4CAF50' }}>Total Paid:</Text>
              <Text style={{ ...sharedStyles.summaryValue, color: '#4CAF50' }}>${data.totalPaid?.toFixed(2) || '0.00'}</Text>
            </View>
            <View style={sharedStyles.summaryTotal}>
              <Text style={sharedStyles.summaryTotalLabel}>Total Remaining:</Text>
              <Text style={sharedStyles.summaryTotalValue}>${data.totalRemaining?.toFixed(2) || '0.00'}</Text>
            </View>
          </View>
        </View>

        {data.notes && (
          <View style={sharedStyles.notes}>
            <Text style={sharedStyles.notesTitle}>Academic Notes:</Text>
            <Text style={sharedStyles.notesText}>{data.notes}</Text>
          </View>
        )}

        <View style={sharedStyles.footer}>
          <Text>© 2025 Software Development East Africa (SODEAF) — Innovating for a smarter Africa.</Text>
          <Text>Crafted by Eng. Mohamed Ibrahim Abdi (Moha-Qadar) | mohamedqadar280@gmail.com</Text>
        </View>
      </Page>
    </Document>
  );
};

export default EgitimReportPDF;
